import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { FooterOptions } from './types';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input() options: FooterOptions = {};
}
